import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  create(arg0: string, arg1: string) {
    throw new Error('Method not implemented.');
  }
  error(arg0: string) {
    throw new Error('Method not implemented.');
  }
  success(arg0: any) {
    throw new Error('Method not implemented.');
  }

  constructor(private readonly notification: NzNotificationService) {}

  createNotification(type: string, title = '', message = ''): void {
    this.notification.create(type, title, message, { nzPlacement: 'topRight' });
  }
}
